import styled from 'styled-components';
import NawyLoadingIndicator from '../../../../new-components/NawyLoadingIndicator';
import ErrorComponent from '../../../../new-components/ui/ErrorComponent';
import { Compound } from '../../types';
import SearchResultCard from './SearchResultCard';
import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { isEqual } from '../../../../helpers/isEqual';
import useMapHelpers from '../../hooks/MapHelpers';
import { points } from '@turf/helpers';
const SearchResults = () => {
  const { isPointWithinBounds } = useMapHelpers();
  const compounds = useSelector((state: any) => state.map.compounds, isEqual);
  const visiblePoints: any = isPointWithinBounds(
    points(compounds.map((compound: Compound) => compound?.coordinates))
  );
  const visibleCompounds = compounds.filter((compound: Compound) =>
    visiblePoints.some(
      (point: any) => point.geometry.coordinates == compound?.coordinates
    )
  );

  const { isFetching, isError, isLoading } = useSelector(
    (state: any) => state.map.searchStates
  );
  const { t } = useTranslation('common');
  const orderFilteredResults = () => {
    return [...visibleCompounds]?.sort((a: Compound, b: Compound) => {
      if (a.isFiltered === b.isFiltered) {
        return 0;
      }
      return a.isFiltered ? -1 : 1;
    });
  };

  const renderResults = useCallback(() => {
    if (isFetching || isLoading) {
      return <NawyLoadingIndicator />;
    }
    if (isError) {
      return <ErrorComponent />;
    }
    if (visibleCompounds.length === 0) {
      return <div className="no-results">{t('no_results_to_show')}</div>;
    }

    return (
      visibleCompounds?.length > 0 &&
      orderFilteredResults()?.map((result: Compound) => (
        <SearchResultCard
          key={result?.id}
          id={result?.id}
          logoPath={result?.image}
          compoundName={result?.name}
          startPrice={result?.minPrice}
          isFiltered={result?.isFiltered}
        />
      ))
    );
  }, [visibleCompounds, compounds, isLoading, isError, isFetching]);

  return <Container className="hide-scrollbar">{renderResults()}</Container>;
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;

  .no-results {
    color: #2c3138;
    font-size: 14px;
    font-family: materialMedium;
    text-align: center;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    overflow-x: auto;
    flex-direction: row;
    align-items: start;
    gap: 8px;
  }
`;

export default SearchResults;
